'use strict';

/*@ngInject*/
module.exports = function ModalController($uibModalInstance, $rootScope, publicUsersService, $q, $window, toastr, authService, sharedService, $http) {
    var vm = this;
    vm.modalInstance = $uibModalInstance;

    var RESPONSE_STATUS_OK = 'OK';

    vm.rootScope = $rootScope;
    vm.startLogin = false;
    vm.passesError = false;
    vm.viewMode = 'logIn';
    vm.title = vm.viewMode === 'logIn' ? 'signing_in' : 'registration';
    vm.user = {
        email: '',
        firstname: '',
        lastname: '',
        pass1: '',
        pass2: ''
    };
    vm.mobileId = {
        code: '',
        phone: ''
    };
    vm.passwordPattern = publicUsersService.passwordPattern;
    vm.phonePattern = sharedService.getPhonePattern();
    vm.emailPattern = sharedService.getEmailPattern();

    vm.signInFacebook = function () {
        return window.location.href = $rootScope.rootUrl + 'facebook/login';
    };

    vm.signInGoogle = function () {
        return window.location.href = $rootScope.rootUrl + 'google/login';
    };

    vm.signInIdCard = function () {
        vm.registrationError = false;
        authService.getIdLoginUrl().then(function (response) {
            authService.idCardLogin(response.data).then(function (response) {
                vm.handleIdLoginResponse(response);
            });
        });
    };

    vm.close = function () {
        if (vm.mobileIdData) {
            vm.mobileIdLoginCancel();
        }
        vm.setLogInMode();
        vm.rootScope.isModalOpen = false;
        vm.rootScope.loginModalOpened = false;
    };

    vm.setSignInMode = function () {
        vm.viewMode = 'signIn';
        vm.title = 'registration';
    };

    vm.signInMobileId = function () {
        vm.registrationError = false;
        vm.viewMode = 'mobileId';
    };

    vm.setRestorePasswordMode = function () {
        return vm.viewMode = 'restorePassword';
    };

    vm.setLogInMode = function () {
        vm.viewMode = 'logIn';
        vm.title = 'signing_in';
    };

    vm.signIn = function () {
        validateForm().then(function () {
            if (!vm.user.authentication_method) {
                vm.user.authentication_method = 'EMAIL';
            }
            publicUsersService.registerUser(vm.user).then(function (response) {
                if (response.data === 'ok') {
                    vm.onLogin();
                    vm.rootScope.showSuccessModal = true;
                    vm.rootScope.successMessage = 'Registreerimise kinnituskiri on saadetud Teie e-postile';
                    vm.user.password = null;
                    vm.viewMode = 'logIn';
                } else {
                    vm.rootScope.showErrorModal = true;
                    vm.rootScope.errorMessage = 'Sellise e-postiga kasutaja on juba olemas';
                }
            });
        });
    };

    vm.logIn = function () {
        vm.passesError = false;
        vm.registrationError = false;
        vm.registrationMessage = false;

        validateForm().then(function () {
            if (vm.viewMode === 'mobileId') {
                vm.mobileIdLogin();
            } else {
                $http({
                    method: 'POST',
                    url: 'publicUsers/login',
                    data: { email: vm.user.email, password: vm.user.pass1 }
                }).then(function successCallback(response) {
                    if (response.data === 'ok') {
                        vm.onLogin();
                        $window.location.reload();
                    } else {
                        vm.rootScope.showErrorModal = true;
                        vm.rootScope.errorMessage = response.data;
                        // vm.registrationError = true;
                        // vm.registrationMessage = response.data;
                        $rootScope.loggedIn = false;
                    }
                });
            }
        });
    };

    vm.logInHash = function (hash) {
        $.ajax({
            type: 'POST',
            url: $rootScope.baseUrl + 'publicUsers/loginByHash/' + hash,
            success: function success(response) {
                if (response === 'ok') {
                    vm.onLogin();
                    $window.location.reload();
                } else {
                    vm.registrationError = true;
                    vm.registrationMessage = 'USER_NOT_FOUND_ERROR';
                    $rootScope.loggedIn = false;
                }
            }
        });
    };

    function validateForm() {
        return $q(function (resolve, reject) {
            vm.showErrors = false;
            vm.isConfirmedPassIncorrect();
            if (vm.publicUserForm.$invalid || vm.passesError) {
                vm.showErrors = true;
                reject();
            } else {
                resolve();
            }
        });
    }

    vm.isConfirmedPassIncorrect = function () {
        if (!vm.user.authentication_method && vm.user.pass1 && vm.user.pass2) {
            vm.passesError = vm.user.pass1 !== vm.user.pass2;
        } else {
            vm.passesError = false;
        }
    };

    vm.restorePassword = function () {
        publicUsersService.restorePassword(vm.user.email).then(function (response) {
            if (response.data === 'ok') {
                vm.viewMode = 'logIn';
                vm.rootScope.showSuccessModal = true;
                vm.rootScope.successMessage = 'a_password_recovery_email_has_been_sent_to_you';
                vm.rootScope.loginModalOpened = false;
            } else {
                vm.rootScope.showErrorModal = true;
                vm.rootScope.errorMessage = 'Kasutaja on mitteaktiivne või sellist kasutajat ei ole leitud!';
                vm.rootScope.loginModalOpened = false;
            }
        });
    };

    vm.mobileIdLogin = function () {
        vm.showErrors = true;
        vm.registrationError = false;
        vm.registrationMessage = false;
        if (vm.mobileId.code && vm.mobileId.phone) {
            authService.mobileIdLoginStart(vm.mobileId.code, vm.mobileId.phone).then(function (response) {
                vm.mobileIdData = response.data;
                if (vm.mobileIdData.status === RESPONSE_STATUS_OK) {
                    authService.mobileIdLoginCheck(vm.mobileIdData.sessionToken).then(function (response) {
                        vm.handleIdLoginResponse(response);
                        vm.mobileIdData = null;
                    });
                } else {
                    vm.rootScope.showErrorModal = true;
                    vm.rootScope.errorMessage = vm.mobileIdData.errorMessage;
                }
            });
            vm.showErrors = false;
        }
    };

    vm.handleIdLoginResponse = function (response) {
        if (response.userIdHash) {
            vm.logInHash(response.userIdHash);
        } else if (response.authentication_method) {
            vm.user = response;
            vm.setSignInMode();
        } else {
            vm.rootScope.showErrorModal = true;
            vm.rootScope.errorMessage = response.errorMessage || 'Sisselogimine ebaõnnestus';
        }
    };

    vm.mobileIdLoginCancel = function () {
        if (vm.mobileIdData) {
            authService.mobileIdLoginCancel(vm.mobileIdData.sessionToken).then(function () {
                vm.mobileIdData = null;
            });
        }
    };

    vm.close = function () {
        return vm.modalInstance.close();
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/modal/modal.controller.js
 **/